<template>
  <div class="page page-user-panel panel-home">
    <user-panel-layout active="home" :rows="0">
      <!-- Inicio de notificaciones -->
      <section
        class="panel-module panel--notifications"
       
        :style="{
          backgroundColor:
            'rgb(' + this.$getUserColor(this.selectedColor).medium + ')',
        }"
      >
        <div class="panel-module--header">
          <h4 class="panel-module--header__title">
            {{ $t("message.admin.panels.notifications") }}
          </h4>
          <!-- <div class="panel-module--header__buttons">Buttons</div> -->
        </div>
        <div
          class="panel-module--body"
          :class="[loading ? 'overflow-hidden' : '']"
        >
          <panel-module-loader
            :color="this.$getUserColor(this.selectedColor).dark"
            :bgColor="this.$getUserColor(this.selectedColor).light"
            v-if="loading"
            borderRadius="8"
          ></panel-module-loader>
          <div class="notifications-list" v-if="notifications.length > 0">
            <notification-card
              v-for="(notification, index) in notifications"
              :key="index"
              :user="notification.senderName"
              :type="notification.type"
              :read="notification.read"
              :timestamp="new Date(notification.date).getTime()"
              :color="selectedColor"
              :projectNameCat="notification.projectTitleValencia"
              :projectNameEs="notification.projectTitleCastellano"
              :projectId="notification.projectId"
              :id="notification.id"
              avatar="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoHCBYWFRgWFhYZGBgaGRkaHRwaGhwcIRkaGRgaGhocHBwcIS4lHCMrIRoaJjgnKy8xNTU1GiQ7QDs0Py40NTEBDAwMEA8QHhISHjQsJCs0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NP/AABEIALcBEwMBIgACEQEDEQH/xAAbAAACAwEBAQAAAAAAAAAAAAADBAACBQEGB//EADkQAAEDAgQDBgUEAQQCAwAAAAEAAhEDIQQSMUEFUWEicYGRofATMrHB0QZC4fFSFGJykiOyFYKi/8QAGQEAAwEBAQAAAAAAAAAAAAAAAAECAwQF/8QAJREAAgICAgMAAgIDAAAAAAAAAAECEQMhEjEEQVEUsTJhEyJx/9oADAMBAAIRAxEAPwD545DeV1z1QXW1kBGBWhRrVZzUCKhRdKkJgRoVSV1zlxqAOhdDVYBdQBxVOq6FIQB1wsqtC9L+nsBSexzqgLu0WwDEQAZMX39EbH/phkF1Bzif8HxJ/wCLhHkfNc/5CUnF6N/8EnFSieTDVfKr1GFpLSCCDBB2PIqhK3MCjiqFWK41MAa6rLsIGUAUhEAXHIFYLKoGFGAXToigsXLFRyZdUAS7qwSdDQJzEubmEarUCCwbrOTGkFzXVi2UIFGAXPJ27OiKpUV+H1UDOqq8wq5kqY7QXIOanwhzQi9TMimFoLkHNRCzKIphaHSjMahhHaF2I5SBdJXZXAqEcXIVg1VlAHHBEa2y40SrgoA7Ko4qErgQB1daorwgDd4BUy03xrnB82j8FeiwlaRMiV5jgDS74jdey0+Rj7rfwlItA07iT9l5udf7s9LBvGhfjXCm1u0OzU57P5B3XqvHYimWOLXAhwMEL6S5kjTyOix+OcL+K2R87flP+Q1yn7J4M7g+Muv0TmwKS5R7/Z4dy4rRBIIuLQutavRPPOEKALpXQ1AHFAF0BQlAiEKp1XVwoABUKSqOTlQIZprOWy0I62TGWAuU2XRHGyxm60a41ewIRxogAooNlmzRMq9UhWeVWU0JkyqZVJUlAaJlUUlRAaNRjEUhdauu1XacpQroUcVxICEqQuK4TA4DC7soVIQBRWaoV0BAHWrq4BsmGYVx0BSckilBvo0P0zVio5v+bCPFva+gK9O8kNzN25Ly/CcI9lVjsjoDr22Nj6Er1rmljrXGnRefnac7Xw9Hxk+FNEw2KDxoCe+FZ4G3rsoS0RLLcwdPA/kKPAiWmR6jwXPJWb9HnOO8HzzVYO1+8c/9w+68yWFfRqZgotThFJ4JyND/AEMn0K2xeU4R4vZz5fFU3a0fNGsPirBq+g4bhdKYDWZhsRJHS6NV4UxsywA87d60fnL4QvCf0+bkqq9uzgzH5ppi24t6LHr/AKdccxZIA2ctIebCWnozn4c47Wzz5VSU/ieG1GasJHMXHmEm9i6YzjJWmc0oSi9oC4qjyERzENzUmIXcodF1wuqu0XLP+R0Q6AhGagozNEmOJV6omaGEfUOWmxz3cmNLiOpjQd61cN+kcQ4S8MpiY7br/wDVsnzhFpdsdN9IwVFpY/hXwfme13/GY9Vmppp9A4tdkUUUQI3nUT1XDSPJemdheYU/0gjSVl+c/aOh+CvTPLGmeSs2mV6M0Wg/KiNwjf8AFP8ANXwX4P8AZ5jIuNYvWf8Ax7NYUHCGO+VpVLzY/BPwn9PKtYuupG1l7SnwNrRJARaHDQ79ohS/OXpAvC+s8fheHveYaJhb2D/SbnfM6On2XqsJw5jdo8gVoUad4WM/LnL+OjWPiwj3sx8D+maTIlsnr91tUeGUwJytEJjQwLDmuYioALGVg5OXbNaS0kL1SwWACQxVNpJ+6YDAT4pHi2GJuDBRFlJbFqTTOXXpr6lOUeHE7a6Ec7DTxS3CsI9xzEzDgDOtvY816VmHAG/Pv0urciWZjcE0QY2GnNDxTJEARafLWfG3gtV7RsI3/KE9tja5tfz8pnzWTdstaMahhspAvJgnprr4A/RFqTOZ1mtB8fyffJOi0HpP899j5pXGNOQhuXNfUmBm5/npySSHytifDBmcXbTpy18yp8YdsZQIEneZFh3krjafwqIJPaMT+OmqVY4fDkgy5wPhzv0GvVIqrYSvUuwHlMazafBK43ANqO+RltnaxfkiZCQXR2pidw0cvI6J6mQ1hHQ3Pv3ITi2uiZJHk8d+nA5xDIYeUkg+K87i+HVKZIewi5E7GOR3X0LC03vdnE8hy53Xa7CDD8pBBGxtuunH5U46ltHPk8WMtrTPlVTVU2Xu6/6YZWqFzJYwawLE7w42C1MFwHDUrloNv+RPe46eC1eeL2kZLx2tNnzrhvB62IdlpMLuZ0aO9xsF7bAfpPD0Wg1z8apqWhxaxvTYu8Y7luPrEgMYAxuwAgnrGo790N9AgHsSPEfwk5yl/Q1BRAuq5W5GsbTZ/ixoA77a+qycTiwNL98/dGxdZrdHFh5XXluKY4glo1OpH26pxiglL6K8bxmd8DQa9T/CzEQtUyrVaMHtglESFEWKj6tjrCQLpGk92wWm94MDdL4h4G0SvLPXQs0A3PkjvGgGilOiXX9laVHAOjNl0SHaFsPQBRn2HZHih53OMZY6J34YAG5+iYmLMaTd0ynqbIHVWw+GtIMnqnWUTHaF+n2SoltAaTT5rRwzLaeH4S2QzZM03jJ7HkqRD2ceznpy/CVLRcaotUzO4QyDy9/VKwQGmDMQitwUmXGehRmANvurMeHGft/COhhKdBobp9iRsSiMfaxnnziFWrUt2dvRAp1zmg2Pn/fkqbJqw7WQJ99FR4BkRyHdNvvPgpiHdmJgnwlLYOoZJcdPd018D1YGsYgd/qJHgL/9llcTeQ4F5hpgwDcxAv5FMYqqXVWMboXRbuCH+oqIdVpN5u06D3Pik+mWtNWExl2gEhpdAaI2O/18YS1SgC1jbgTA6gG8+AKLxV7GlrtwJ10kGbbfylMTjsrcwEuu0cgIMnvt6oY0MYJhc86ZB2Ce6JPmk8eHGoA24Mk99/T8hMvqfCpNBPaJM667nwnzhDwr3OeHRDLR4DS/uSUUK92hxgys7hbz1POyy8exp1EkGRPKdD6LRdVH/wBQD3RN48JCTezNGWTeSTzAjzkhU0SpHH445INgLADaPYWY7FEzctHM6noOQCceDEfLOY+pj6eizMTgiJcCWja0k9Y/r1WkEjObOVMQ3QZidzLr+QlJVKkaE+Dp+olUxDXR8zz5x6WQWsgEk2F9NlskZgcfinNbmmTo0HnzWLmafmBB5i6crVw8302HJD+H5LrhiSjs4smVuWugHwAflcD0NigVWubq0hOOpdFajiQJDg4QJO4jmeQQ4JCU2zK+OFF6Gngg4Bwpgg3nKbqKKQ7Z7DDVCXXt0Rm0y50HSV2jRMaJvCME8l5J7Q9g8MAecI+NxWVsN39EJryNEHEGblF0iat7LYZkdrf7ojKeYyY981VgcG3iUzh2yIBjuSQ2Xa4G2ka6JlhBMSY70mxsbCT4phlODbdMlhAL2R6rIaLqjm37vBWeZbr9D/SZDBtE+49EKpbRcbUvr77wqYoE2HekUlssWl179fFK1sYWDKwZnHWxPnCUfhahsXho6mD5rU4Zw7IJddxGuqEmym1FbM34FV4zOfl6DVNYPC9rN8Vx7/pBT2LYBZxgnQx6LGrPLHXBHI7HxRVAnyRpPeHOLD2TtNg7uIsT6o76Jaxw6eJStCtTrS14AOgMxB6HZZmNxdfCO7f/AJaOzo7bOjho4dRfvWsaZm0+gnBab873vmwLRPMn8IvGMO5zg8G7fzPncpuhU+LTD6YlpEgjkuUWOcx0mDt0MDL5EBHFJUDk27MDHuzPI1jLm9IA8Y8FbCUWhozWDZJn/c4ajlaI6pxmEGYSJk3vsCY+ytjsO0ghx1AF4uRr9I8VNWVySVCFMOxH7YZmzZjuATpPfr3KVca0vDGDstOm5PX07u8rSrV2so2iA21+RgecLE/TVDM42zGZ5TyPvmqqiU7v4jVFEuEusNbRe5v0A57mNUKrTy3aIA56AazG94gb76J7imKZTIaASTrtJ58yfRKB+YWEeN/ym6uhK6sTew66cgdYFhPIb+4WfitLgvHdr4fc/wALUqw2ZGmwk+d0jXdMzPKwBgnppPuyqLoiRhNxDSYlwPLb0j6LK/UGIDcrQ43uRAHitoUBn07yXST4wPJeT43iQ+oYu0dkbaLpxVys58z1QBtVPYMPe4NYC48v5SmB4c6o7cN3MT5cyvf/AKf4S0NAa0gSJJBlxB3kSV1c/hycRbhf6akgvM7lomPEhewwHCWU2w1jRaNAZF7OJ+a5+iYw+GawCZnn75280ao0OsQS1sX27uvclbY6o5TaYEAeIv4ris6nzAnuB7vRRAzGofKiYNhzIVJxvAt1RsO6Nj+F4p7IxWfA08klmuOScxB5GPfPZLYkjKLC24SY0XfUtFoTGGeA3Ud1x9llh5yanXcz9Qn8MbCDOyENrQ5hycwuFpNaCk2AQLfz91pUAHCDYJpGcmCAAGqoRzEoxZFgfBDcNiPomSJVKZDuiM1vbFhouP2/BMeSFjJzA69wn6pob2aJoD5mx4wPOyvhmZR2j9PssWtxfJDSwmPD7JLEcTe8QxpHfp5q+Ssng6N/HVmkRMW5j6WXncSbSHy33ryRcNhc16hk8tvufUKtbhwvkEE8wlK3scWlqzNqYlrROiPW4oHUrkE+BB6odbhxMg29R1SVXBdnKBJO6jpGq2z0/wClOItNFzG/tce4SSVqDD9meev19ZKwP0vwz4QvqY8916SvXa1sAydJ6q1KzKUaejJxPZBm0e/rBXm2561Q3MD8n8len4rXaWQBfQ/yvLUuKMpSf3GwCtaJ2zRqYUZSx7gAdSTHvdPcKpsptIaWyet1hYXg3+pcX1qjySbta4gNESAI+vetgfpvBsElhJn9z3n6O3RyVhxaVBcS5kyS0n/KRMeQCTrVwBIeCNhM+gMlTEYbCtMsZBnUkkd1zYpbEtY4RDb7QZ9D9Qk2rKUXQCpVc4WdfWPyAlKzyBNp5AwPuUCo80nQTLToVSriAbykmJoV4m172Qw5XOjbYmNVnYTgdNgmsc7tmtMDxOpW5VcS2QTPLYlLYThtV75LHEA3gGOf2XVhlrZy5o70P8K4fnILoY3RrBAhoPu/VetoUsoGW3l123SOEwb2Nb2XbbG3itLDg5r7SI8Bc93lfxXRFo5mmi1Myd47tdjJjz71CSD8sid9ANAYJ+iO8GefIb6BBLB+2J5gaTPf3i4ViL5zz+n5UVfhtOrZPUNnx7S4gRhUnapjDVTpKTw57WoTlFoGg9V4p7QSq6UNzhHPuVqoMJZvKPJJ9jXQKm+ZHXT+1tYWn2RefX6LIoMh2luq3sO9uXmURQSYRtIvcBJHonjRI7IMhUwzgBNl0VwJyme/7K6Rk22EFMxyCG7kdFH4kG03QSQQb+R+6X/A37KVSZsPGJhdrMc5oMTHIR9pVHtGsnw/MoTXgg9Obp/9QrihSZb4siCwzveOUzmsqOqNA+XTb5QB3skD/qkXEA5gWAf7XVR6NCs3iIJ+dh8HmPB5bfrdbRS+ozYxTBNwY6fOI65bjxaE5WZlAOxHzA2naIVsLTY/tZCTrIcBp0JMeSJjHgAgscRGxJPjGvoiUUkKLtmU2s0nKf6n6IuMY1rC61hOyAyk3MchBBAaWP0jxTWMoSyGgAAQBt5LDZ0Kk0ZeCxpa2Qef9rj8ZJDSeep890JhaAWbjW+hO0cko6nDpMIjE0kn2GxGMAacztz19wvONwBe8OnUGOl1OLVZeGi8nTlsvUcMwoAbzAEdLCVVNGdpF5NJga03jWRfnJvHvvWfVxg5R1InXXRbddkjSbXE69b+79ViYjCvaSReTyA8EuNByRVrJlxLQOZkHTv7rKPkTDh75y5Aq1Q0zkdHTQx0m/fKoziBe6KbL87ADvsnxE5CmOAfIuHayD9pgo3B+D1H2dpIAJkdTr0W1hMCBd9zqVrUnmwa1LkkJpsHgODsY0AgOOpJG408l6OhhWhov6LBr4l9O5IA5/RFwvEy4C9o5hHP6S4fDVxFcsBtLef8LIqY4OMjXmrVK0zJ8CsjF18r3X+UZtdPx6K4crtESUa2awxAJF/ZGn11R6Uib/LAB5iBY6xAOlpWDwGqaxc4fIDAMWJ1MDdegc3lYXm3p5r0U9HA+xarRJJIcB4N2tyUTtNwgaHz/CidiPI02AOWixzY2lIsdB0BTQre9l457AUCRMpLFui8lNF3M/dZmMPIkqWikWFUOiNeXIdVuYd7AwDUzz9V5ijWvH1WxhGudBAtudABy6lCHJaPQ03WAmBqY/KYogOvsOcoOCo9kT5d3NOF4nKPRaJGDfwHUps5DyS1XCjUH7QnCY28SErXroaQJsQr4U/5D1/tLshpkyenuT6BTE43Lb6LMxGO1zDwj68vqpjKKZpxbRr1i1xzNGYnYknTWzBPqEKnUAMhjBHMON+sufl8gsWnxWLR2TsBcgXGpt6larWNeJAgnmb/AM/RbKXtGTj6ZuYDGN0hoP8Ata0+oCrxQ75i33uC4D0WPRqFtiYaO4T5J+liWublkK1JSVMzcXF2hMsa65YHCZLmnykXTTCIPat3CY5DceKTrUXNMgFw70nX4mBYyD3LPia8rO8Yaxhz/uy3IvysYXn8Xiq7zlpMBA+YkE67WTGPxRfAAOXMCT4iQE9/qIZDQA3WwuT15nVaVSKWR1SMjCcNIOeo4ZuWw81p0sZkDgH5i0CWhpPiCLG23RK4jFzo4SN47510QaWMfoHsknTLr0FjfwU1ZFmi3iDiYDHl0TAbA81n8S42ymcr7G3ZBBJ8sx84CQ4lxMNOWo+pJ/ZA+ognvhK4DhPxH54gHSSdu8SrSUVcjNtydRHKLn4jYsZy52tN7Bel4bgmsaIGwS+CweW0ARfv9hOvqBsc/f8AK5pzbeujpjBJDcAGT5Kj8flssqvinTz99VKlSRc89D9lNDbNKpiyRsdbQkWVndptrabRPTzv0WbX4iKd3HQ8tUtwjFVatYuax7mEahphu1zYX+y3hib2YTyqOjYxPEvgsJdoJ0Nz0SfCMC/Gdt2ZlMmHc3RPZafqdFvUv0yx7g6v/wCS0NZcNHMm8vJ6xpot4vIsG28IAG1tF2Qx8UcU8nJgaVIMaGsADQQIHmfyo4A3MHUDeb8/TyVaxIEzG1jM62BKG6kdQALRfWCCb8rhbpGLYa+5APTL4ei4smq6Ce0P/wBHW/NRVQjJo1JjmtBgkaCepAWRRzE/daVGm7m37rxT2bGXxG47rrPxJF7z3wtAu218Qs+swTKllREqLBK9BhHHKANLLANytzg/y3595SLl0elpN7I/CLTEJehUO0+P4TLnQL7BanMAxVbaNPfcsbE1CTofD39k5XeScrdTvFgqUsECSdhuSAD4BZytmsaj2J0sCD2nCO+fyiOwTDfKD4a+Sfc0GAIP0VK8Aaye735pVQ+TZl4jDtFgALQIGnjslGYdpMAnqb7dPymcY8/KO1O97CYNkviH5Oy03uYi55zz59yabCkDfiXt+SHgakjN4CP6QmcWdnEtb3j6N5pihROUxa+x6XjYbeSAKHaE994NwBv4+qtSolxRs4bHhzezfYiUDEUATJCy8QxzGgtJaZJvyv53PuFV+PqBoDrxqea0UkzJxcRyvhGgEd0W9+wsfF03NPZPgVMTxfKCCD7/ALKxqvE3kGy0RDbC4jE5QZtHjeyyamPe45RYcxcj+OiKyi95BcZWrg+HAGY0v79E7ihVJivDeHvkZ3OcJ0cczechpkeK9PhDkAlovygSfDTwSrHgAQJFxfut9QFSpig27vA+AN727ljJykzaKjFG214I7uY0P9z5pLEVQ0TEWGtzvp5A+KtwqlVrNa5jbEDtTA6O3GoMjmCtvA8Ba0h1R2dwIIAs1pBBBjfQGNFUcEmRLPGJ5DC06ld4axp6mDlbabuFhMRrrHetKlwLEH53MYJM3JMW02PmvYUw4GAAG+5jkieBvF+S6Y4Irs5555Po8kP0Wx5/8r3vAmAOwL6EnUnex/C9FRpspsDabWta2MrRYC3998lFz99pnaAPFLPxDLaDMCIkQT4/YLeMUujnlJvbJVe4Cf3RbYXPml8RiS2YbJPIknn3oNZwm5iBFgLdB72SGIrOYDZ5bd0kgT+B33VUTY7icWQJPZgTBsegI3v5SkqOOJa6XAzaJ7PMyRcD8pF+OZlc58Q42bnJgR0Enb1WdisQ0AuI7TjaTZrZAMNBk/RMRtYjibi4luQi0ERBgRaXKLzNTENm5qA2kMIa0W/aJsFE7A28M4gbynTmjn4wg0WaahOU2n/KfIryGj10zlJhI0Pj/S47DXGnlKcY9MMYOQ71DjZSlRjYnD2gR3prhIhut5TOJbruu8IwwDiprdFctWbOEtcjz+soeNqZRqJPuyu43udB5JN7czwBKp9UZruzmCouIzOtmMAbxzJ+wTVUAwxjYHX780TJcNaLRc/aeSYawNvqduifHVCct2KlkWG39SSlcYQBlFzqSfD8o1WoZI/aPU8h+UjXrDMQSAALxvb33wpY0UeWgg9bDnEm/qUhVpZqjAdSSLbuLST4Bsp6syIdr2T4TqR6eiDgqcvDpuL+Ux3bpe6NE9WHcwBkCeyQJ5k39UsWRUHOPwLeBWg9ktGl3eoNvIN9ElSbNRzokg6X0kAes+qpr0iVJbbC1aEsEi7QLcwGj8pKvhpBEzp4dmU657iHgACSIJO8kfQDyWZUe5n7g6w03AEXG1hHgFqsUu6MXlj1ZmY/AWJjcT5wkaOEBbG9yfCV6qjhHVWBzBYie0Y1sfLLKYwn6dDXFz363LW8zO/KPr3K445Ml5IpHleG4J73EMaXQRMCwkGCTt8vqvR4P9PkHtv2Fm7GLOJJ538l6KhhWsZla0NA/G99Y3XWwba99+a6I4UuznlmbejFrfp2m4zL9RIkC0bwE3R4HQZMMbO+aX/+xPNaDhNpt036k7hKuxRbN9Be1/ditVjS9GTyN+w9mw0COQHKNuQ2VPiEuIIjLFiOZ/Cz8TjDNwW2iZjXQRr/AGgvxsReLakG86AG5GiriTyNqkZBjZ0W0lDxFfIDfLa28/m/okm12tOYuy7ZS7XbmgY+uHNBzN6T+53JvkQmkJs7jcTmJaCA69rE6Rc6eCTNZzSTldaWzO/OT05c0o/Elru24S5wGg7JdIPeZB30ul8VxMSxxqPMXDGxYCcxIFmgbmdCmIcxFdzoDW5QBdxMTa5MW+6w8fimNcTZ/wC0giQ6ZswEyfl1WZxT9QObY1JjTbtAXIym1/OF5jE8Wc50tsd3bmxvfe5QBv4/jLgZf2SLZezAvs0C2iw8Rxiq92ZriLETprEwBYTCSbT3NyrfDSAG97yZLjfqoiQoixH1SnUOv1TNOkDqoovLZ6qGG1A3ZXfi7TsuqKSgfx2m8J/hroJJG1h91xRJlDTXl19JI8kxhqMTpJUUQiWHa8XPLfv5eYS9SuGiSbgWtoFFFvCKfZjOTXQl/qBIubuI03GvvoEGnRaSXlpkyXZjJAm2hjnzXVF0rDD4czzT+ncQ4ZZyiLa8rXjSTNgdJulqL2teWtALnOnc6kwSTA2noooqeOHwSyS+jhp1eTRyvob2sJ5/ynW0MrRmOZ0eBJv4fwuKJqKJlJsliJMAGDET05bqzMEySQ1ubnF+dth4KKKqRNsOR1vt9UEVTbSfHyUUTSA7iKkEDWSJ7j7KUxGOayBlInSDruD/AH0UUVEgKvEGxLZMATM72EcyBPJZtTHktJc3M0mQTAi9tLxqoomAs3FsAJvYEkS65Itfp91TE41rWkuGUwIEuuTpOXZRRACFfHB0hozEgvAIBAaLky4zfl0SXEeIFkscQ10SQGxF4AGXs7eqiiQHnT+oCDOY6QBuJBAvA2N1m4viz3mQcs6kAAmdRbZRRACLaRNymadNRRIC5C4VFECOKKKIA//Z"
            ></notification-card>
          </div>
          <span class="text-lg">  {{ $t("message.admin.panels.noNotifications") }}</span>
        </div>
      </section>
      <!-- Fin de notificaciones -->
      <!-- Inicio de actividad en tu zona -->
      <section
        class="panel-module panel--zone-activity"
        :style="{
          backgroundColor:
            'rgb(' + this.$getUserColor(this.selectedColor).medium + ')',
        }"
      >
        <div class="panel-module--header">
          <h4 class="panel-module--header__title">
            {{ $t("message.admin.panels.yourZoneActivity") }}
          </h4>
          <!-- <div class="panel-module--header__buttons">Buttons</div> -->
        </div>
        <div
          class="panel-module--body"
          :class="[loading ? 'overflow-hidden' : '']"
        >
          <panel-module-loader
            :color="this.$getUserColor(this.selectedColor).dark"
            :bgColor="this.$getUserColor(this.selectedColor).light"
            v-if="loading"
            borderRadius="8"
          ></panel-module-loader>
          <!-- MapCug -->
          <UserMap></UserMap>
          <!-- End MapCug -->
        </div>
      </section>
      <!-- Final de actividad en tu zona -->

      <!-- Inicio de resumen de estadísticas -->
      <section
        class="panel-module panel--insights-resume"
        :style="{
          backgroundColor:
            'rgb(' + this.$getUserColor(this.selectedColor).medium + ')',
        }"
      >
        <div class="panel-module--header">
          <h4 class="panel-module--header__title">
            {{ $t("message.admin.panels.insightsResume") }}
          </h4>
          <!-- <div class="panel-module--header__buttons">Buttons</div> -->
        </div>
        <div
          class="panel-module--body"
          :class="[loading ? 'overflow-hidden' : '']"
        >
          <panel-module-loader
            :color="this.$getUserColor(this.selectedColor).dark"
            :bgColor="this.$getUserColor(this.selectedColor).light"
            v-if="loading"
            borderRadius="8"
          ></panel-module-loader>
          <div class="insights--container">
            <div
              class="insights--item insights--total-projects"
              :style="{
                backgroundColor:
                  'rgb(' + this.$getUserColor(this.selectedColor).light + ')',
              }"
            >
              <h5 class="insights--item__title">
                {{ $t("message.admin.insights.yourProjects") }}
              </h5>
              <div class="insights--item__value">
                {{ totalProjectsCreated }}
              </div>
            </div>
            <div
              class="insights--item insights--visualizations"
              :style="{
                backgroundColor:
                  'rgb(' + this.$getUserColor(this.selectedColor).light + ')',
              }"
            >
              <h5 class="insights--item__title">
                {{ $t("message.admin.insights.visualizations") }}
              </h5>
              <div class="insights--item__value">
                {{ totalProjectsViews }}
              </div>
            </div>
            <div
              class="insights--item insights--saved"
              :style="{
                backgroundColor:
                  'rgb(' + this.$getUserColor(this.selectedColor).light + ')',
              }"
            >
              <h5 class="insights--item__title">
                {{ $t("message.admin.insights.saved") }}
              </h5>
              <div class="insights--item__value">{{ totalProjectsSaves }}</div>
            </div>
            <div
              class="insights--item insights--likes"
              :style="{
                backgroundColor:
                  'rgb(' + this.$getUserColor(this.selectedColor).light + ')',
              }"
            >
              <h5 class="insights--item__title">
                {{ $t("message.admin.insights.likes") }}
              </h5>
              <div class="insights--item__value">{{ totalProjectsLikes }}</div>
            </div>
          </div>
          <div class="insights--graphs">
            <panel-module-loader
            :color="this.$getUserColor(this.selectedColor).dark"
            :bgColor="this.$getUserColor(this.selectedColor).light"
            v-if="loadingChart"
            ></panel-module-loader>
            <user-chart ref="projectChart"></user-chart>
          </div>
        </div>
      </section>
      <!-- Fin de resumen de estadísticas -->
    </user-panel-layout>
  </div>
</template>

<script>
import UserService from "@/services/user.service";
import projectServices from '../../services/project.services';
import UserMap from '@/views/MapCugUser.vue';
import NotificationCard from '@/components/Cards/NotificationCard.vue';
import UserPanelLayout from '@/components/Layouts/UserPanelLayout.vue';
import PanelModuleLoader from '@/components/Loaders/PanelModuleLoader.vue';
import UserChart from '@/components/Charts/ProjectChart.vue';

export default {
  name: "UserPanel-home",
  components: {
    UserMap,
    NotificationCard,
    UserPanelLayout,
    PanelModuleLoader,
    UserChart
  },

  data: () => ({
    active: 'home',
    project: null,
    mapClass: 'map-proj-unselected',

    info: null,
    loading: true,
    loadingChart: true,
    errored: false,
    modal: false,

    projectSelectionClass: 'sel-proj-unselected',
    catSelected: null,

    stats: {
      totalValue: 0,
      percentLabeled: 0.0,
    },
    selected: null,
    items: [],

    // Notificaciones
    notifications: [],

    //stats
    datasets: [],
    chartData: {
      labels: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
      datasets: [
        {
          label: 'views',
          borderColor: '#90EA42',
          backgroundColor: '#90EA42',
          data: null,
        },
        {
          label: 'favorites',
          borderColor: '#F9E02B',
          backgroundColor: '#F9E02B',
          data: null,
        },
        {
          label: 'stars',
          borderColor: '#A76DF2',
          backgroundColor: '#A76DF2',
          data: null,
        },
      ],
    },
  }),
  mounted() {
    this.$store.dispatch('users/getUserProjects');
    this.$store.dispatch('users/getLoggedUser');
    this.getAllNotifications();
  },
  computed: {
    selectedColor() {
      if (this.user && this.user.color) {
        return this.user.color;
      }
      return 'default';
    },
    user() {
      return this.$store.state.users.loggedUser;
    },
    projects() {
      return this.$store.state.users.projects;
    },
    totalProjectsCreated() {
      return this.projects.length;
    },
    totalProjectsViews() {
      //sum views in all projects
      return this.projects.reduce((acc, project) => {
        return acc + project.views;
      }, 0);
    },

    totalProjectsComments() {
      //sum length of comments in all projects
      return this.projects.reduce((acc, project) => {
        return acc + project.comments.length;
      }, 0);
    },

    totalProjectsSaves() {
      //sum length of saves in all projects
      return this.projects.reduce((acc, project) => {
        return acc + project.chatRequests.length;
      }, 0);
    },

    totalProjectsLikes() {
      //sum likes in all projects
      return this.projects.reduce((acc, project) => {
        return acc + project.projectFavorites.length;
      }, 0);
    },
  },
  methods: {
    onResize() {
        this.resizeInsightCanvasDesktop();
    },
    resizeInsightCanvasDesktop() {
      if(this.$vuetify.breakpoint.width >= 1024){
      const insightsResume = document.querySelector('.panel--insights-resume');
      let height = insightsResume.offsetHeight;
      insightsResume.style.height = height + 'px';
      }
    },
    getAllNotifications() {
      this.loading = true;
      UserService.getAllNotifications()
        .then((response) => {
          this.notifications = response.content;
          this.getStats();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async getProjectStats(id, dateStart, dateEnd, index) {
      await projectServices.getProjectStats(id, dateStart, dateEnd)
        .then((res) => {
          //update chart data
          //use $set(vm.items, indexOfItem, newValue) to update array items
          this.$set(this.chartData.datasets[0].data, index, this.chartData.datasets[0].data[index] + res.views);
          this.$set(this.chartData.datasets[1].data, index, this.chartData.datasets[1].data[index] + res.favorites);
          this.$set(this.chartData.datasets[2].data, index, this.chartData.datasets[2].data[index] + res.stars);
        });
    },

    setLabels() {
      //get last 7 days and add to labels
      this.chartData.labels = this.getLastDays(7);
      this.chartData.datasets[0].data = Array(this.chartData.labels.length).fill(0);
      this.chartData.datasets[1].data = Array(this.chartData.labels.length).fill(0);
      this.chartData.datasets[2].data = Array(this.chartData.labels.length).fill(0);
    },

    getStats() {
      this.loadingChart = true;
      this.setLabels();
      // create a promise that resolves when all calls to getProjectStats() are complete
      const promise = new Promise((resolve) => {
        if (this.projects.length === 0) {
          resolve();
        }
        let completed = 0;
        // foreach project, get stats
        this.projects.forEach((project) => {
          //for every element in chartData.labels, get stats
          for (let i = 0; i < this.chartData.labels.length; i++) {
            //get stats for each day
            if (i === this.chartData.labels.length - 1) {
              //if last day, get stats from day to tomorrow
              this.getProjectStats(project.id, this.chartData.labels[i], this.getDayTomorrow(), i).then(() => {
                completed++;
                // if all calls to getProjectStats() are complete, resolve the promise
                if (completed === this.projects.length * this.chartData.labels.length) {
                  resolve();
                }
              });
              break;
            }
            this.getProjectStats(project.id, this.chartData.labels[i], this.chartData.labels[i + 1], i).then(() => {
              completed++;
              // if all calls to getProjectStats() are complete, resolve the promise
              if (completed === this.projects.length * this.chartData.labels.length) {
                resolve();
              }
            });
          }

        });
      });
      // when the promise is resolved, update the chart with the new values
      promise.then(() => {
        this.loadingChart = false;
        this.$refs.projectChart.updateValues(this.chartData);
      });
    },

    getLastDays(days) {
      let date = new Date();
      let labels = [];
      for (let i = 0; i < days; i++) {
        labels.push(this.getDay(date));
        date.setDate(date.getDate() - 1);
      }
      return labels.reverse();
    },
    getDay(date) {
      //get day in format 2022-12-01
      let day = date.getDate();
      day = day < 10 ? '0' + day : day;
      let month = date.getMonth() + 1;
      if (month < 10) month = '0' + month;
      let year = date.getFullYear();
      return `${year}-${month}-${day}`;
    },
    getDayTomorrow() {
      let date = new Date();
      date.setDate(date.getDate() + 1);
      let day = date.getDate();
      day = day < 10 ? '0' + day : day;
      let month = date.getMonth() + 1;
      if (month < 10) month = '0' + month;
      let year = date.getFullYear();
      return `${year}-${month}-${day}`;
    },


  },
};

</script>

<style lang="scss" scoped>
/* Single Panels */

//Global rules
.panel-module {
  border-radius: calc(var(--base) * 2);
  display: flex;
  flex-direction: column;
  padding: calc(var(--base) * 2);
  transition: all ease-out 0.2s;

  .panel-module--header {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    padding: calc(var(--base) * 0.125);

    // margin-bottom: calc(var(--base) * 2.625);
    &__title {
      font-size: calc(var(--base) * 2.625);
      line-height: 1;
      font-weight: 600;
      max-width: 90%;
    }

    &__buttons {
      display: flex;
      justify-content: flex-end;
      margin-bottom: calc(var(--base) * 1);
      min-height: calc(var(--base) * 4);
    }
  }

  .panel-module--body {
    width: 100%;
    height: 100%;
    // background-color: white;
    // border-radius: calc(var(--base) * 1);
    display: flex;
    flex-direction: column;
    gap: calc(var(--base) * 2);
    overflow-y: scroll;
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    position: relative;

    /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }
  }
}

//actividad en tu zona
.panel--zone-activity.panel-module {
  width: 100%;
  max-height: calc(var(--app-height) * 0.5);
  min-height: calc(var(--base) * 10);
  height: 100%;

  @media (min-width: 1024px) {
    grid-column: 1 / span 6;
    grid-row: 1 / span 4;
    max-height: auto;
    // min-height: auto;
    height: auto;
  }

  .panel-module--body {
    height: 100%;
    display: block;
    gap: 0;
    background: rgb(var(--bodyBg));
    border-radius: calc(var(--base) * 1);
    overflow: hidden;
    height: calc(var(--app-height) * 0.4);
    @media (min-width: 1024px) {
      height: 100%;
    }
  }
}

//notificaciones
.panel--notifications {
  width: 100%;
  // height: 100%;
  max-height: calc(var(--app-height) * 0.5);

  @media (min-width: 1024px) {
    grid-column: 7 / span 4;
    grid-row: span 4;
    height: auto;
    max-height: auto;
  }
  .panel-module--body {
    min-height: calc(var(--app-height) * 0.3);
    height: 100%;
  }

  .notifications-list {
    display: flex;
    flex-direction: column;
    gap: calc(var(--base) * 1);
  }
}

//Resumen Estadísticas
.panel--insights-resume {
  width: 100%;
  height: 100%;

  @media (min-width: 1024px) {
    grid-column: 1 / span 10;
    grid-row: span 6;
  }

  .insights--container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    gap: calc(var(--base) * 2);

    @media (min-width: 1024px) {
      display: flex;
      flex-wrap: nowrap;
    }

    .insights--item {
      border-radius: calc(var(--base) * 2);
      width: 45%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: calc(var(--base) * 2);
      padding-top: calc(var(--base) * 2);
      padding-bottom: calc(var(--base) * 1);
      height: 100%;
      min-height: calc(var(--base) * 13.75);
      box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08),
        0px 4px 6px -2px rgba(16, 24, 40, 0.03);
      grid-column: span 1;

      @media (min-width: 1024px) {
        width: 20%;
        min-height: calc(var(--base) * 19.5);
      }

      &__title {
        font-size: calc(var(--base) * 2);
        line-height: 1;
        font-weight: 500;
        margin: 0;

        @media (min-width: 1024px) {
          font-size: calc(var(--base) * 2.625);
        }
      }

      &__value {
        font-size: calc(var(--base) * 6);
        line-height: calc(var(--base) * 7);
        font-weight: 500;
        margin: 0;

        @media (min-width: 1024px) {
          font-size: calc(var(--base) * 8);
          line-height: calc(var(--base) * 8.75);
        }
      }

      &:nth-of-type(1),
      &:nth-of-type(2) {
        width: 45%;

        @media (min-width: 1024px) {
          width: 33%;
        }
      }
    }
  }

  .insights--graphs {
    background-color: rgb(var(--bodyBg));
    border-radius: calc(var(--base) * 1);
    height: 100%;
    height: calc(var(--app-height) * 0.4);
    overflow: hidden;
    // padding: calc(var(--base) * ) calc(var(--base) * 2);
    @media (min-width: 1024px) {
      height: 100%;
    }
  }
}
</style>